import ImageUpload from './ImageUpload.vue'

export class VImageUpload extends ImageUpload {}